const COMPILED_CONSTANTS = {
    "SubDomain": "vbc.qar",
    "qarCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E3PYW273NLM1R4",
    "qarCloudFrontDistributionId": "E3PYW273NLM1R4",
    "qarApiCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E7TZ9ILHF1EHQ",
    "qarApiProxyUrl": "https://qar-proxy.vbsp.test.nasco.com",
    "qarNascoDomain": "vbsp.test.nasco.com",
    "qarOriginAccessControlId": "E1JTRRXKH5PXQG",
    "qarFrontendBucketDomainName": "qar-frontend-242201270467-us-east-1.s3.amazonaws.com",
    "qarFrontendBucketName": "qar-frontend-242201270467-us-east-1",
    "qarApiGatewayId": "eguzkz6037",
    "AppConfigConfigurationProfileFeatureFlagsId": "8meq0hp",
    "AppConfigEnvironmentId": "41l9glt",
    "AppConfigApplicationId": "imckmo5",
    "nexusEvolveHomeCloudFrontDistributionId": "E21XFA9FERZYJ7",
    "nexusEvolveHomeCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E21XFA9FERZYJ7",
    "nexusEvolveHomeFrontendBucket": "nexus-evolve-home-frontend-242201270467-us-east-1",
    "nexusPublicApiGatewayId": "lfkq31jjaf",
    "nexusApiGatewayId": "4xp6zjzrai",
    "nexusUserPoolId": "us-east-1_7NdxEqiTV",
    "nexusSecurityGroupId": "sg-0b1d08ba2e08571e0",
    "nexusCognitoDomain": "nexus-vbc-242201270467-us-east-1",
    "nexusUserPoolClientId": "tcrq7u2koiocq2d4qr3k0n1pl",
    "nexusCognitoSecurityGroupArn": "sg-077518c3422fa0307",
    "nexusLambdaSecurityGroupArn": "sg-0e3e745fd9a2717ae",
    "nexusWardenSecurityGroupArn": "sg-071768aed681c9466",
    "auroraPostgresSecurityGroupArn": "sg-0261dbdddb4c06747",
    "nexustoprocessBucketName": "nexus-to-process-242201270467-us-east-1",
    "nexusfailedprocessingBucketName": "nexus-failed-processing-242201270467-us-east-1",
    "nexusprocessedBucketName": "nexus-processed-242201270467-us-east-1",
    "nexusdynamoBucketName": "nexus-dynamo-242201270467-us-east-1",
    "nexusquarantineBucketName": "nexus-quarantine-242201270467-us-east-1",
    "nascoNexusLambdaExecutionRoleArn": "arn:aws:iam::242201270467:role/nasco-nexus-lambda-execution-role",
    "nexusNascoNexusRedshiftRole": "arn:aws:iam::242201270467:role/nasco-nexus-redshift-role-nexus",
    "nexusRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:242201270467:workgroup/a8c1ca48-45fd-4f00-b943-a3d1add7f61a",
    "nexusNewSubDomain": "vbc.nexus.fe",
    "nexusFrontendBucket": "nexus-frontend-242201270467-us-east-1",
    "nexusCloudFrontDistributionId": "E1VS5V7DZ1OCJE",
    "nexusCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E1VS5V7DZ1OCJE",
    "nexusProjectPrefix": "nexus",
    "nexusNascoDomain": "vbsp.test.nasco.com",
    "nexusApiProxyUrl": "https://nexus-proxy.vbsp.test.nasco.com",
    "nexusAwsAccId": "242201270467",
    "nexusnexusApiDomainNameDomainNameArn": "arn:aws:apigateway:us-east-1:242201270467:/domainnames/nexus.vbsp.test.nasco.com+a1sm84y6vg",
    "nexusApiCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E1ZEEZKAGY2M6C",
    "evolveAppInferenceProfileArn": "arn:aws:bedrock:us-east-1:242201270467:application-inference-profile/zvw1lju6zrsf",
    "evolveAppInferenceProfile46Arn": "arn:aws:bedrock:us-east-1:242201270467:application-inference-profile/tk25la9b7jv2",
    "evolveContractIngestionApiGatewayId": "fzea40uomj",
    "evolveSettlementApiGatewayId": "x5zbd4m1x5",
    "evolveNexusPublicApiGatewayId": "rzs2k4x554",
    "evolveNexusApiGatewayId": "hph6bt26yl",
    "evolveOSApiGatewayId": "b120gdd6lh",
    "evolveNascoNexusRedshiftRole": "arn:aws:iam::242201270467:role/nasco-evolve-redshift-role-nexus",
    "evolveRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:242201270467:workgroup/8bca94df-6cb9-4b32-8e6d-a8b0dc525382",
    "RedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:242201270467:workgroup/8bca94df-6cb9-4b32-8e6d-a8b0dc525382",
    "evolveRedshiftSnapshotLambdaRoleArn": "arn:aws:iam::242201270467:role/nasco-evolve-redshift-snapshot-lambda-role",
    "evolvenexusToProcessBucketName": "evolve-nexus-to-process-242201270467-us-east-1",
    "evolvemediaBucketName": "evolve-media-242201270467-us-east-1",
    "evolvesynthDataBucketName": "evolve-synth-data-242201270467-us-east-1",
    "evolveAwsAccountId": "242201270467",
    "evolvenexusFailedProcessingBucketName": "evolve-nexus-failed-processing-242201270467-us-east-1",
    "evolvemigrationBucketName": "evolve-migration-242201270467-us-east-1",
    "evolvereportsBucketName": "evolve-reports-242201270467-us-east-1",
    "evolvedevBucketName": "evolve-dev-242201270467-us-east-1",
    "evolvesettlementArtifactsBucketName": "evolve-settlement-artifacts-242201270467-us-east-1",
    "evolvenexusProcessedBucketName": "evolve-nexus-processed-242201270467-us-east-1",
    "evolvequarantineBucketName": "evolve-quarantine-242201270467-us-east-1",
    "evolvetemporaryBucketName": "evolve-temporary-242201270467-us-east-1",
    "evolveflowArtifactsBucketName": "evolve-flow-artifacts-242201270467-us-east-1",
    "evolvedynamoBucketName": "evolve-dynamo-242201270467-us-east-1",
    "evolvecontractUploadsBucketName": "evolve-contract-uploads-242201270467-us-east-1",
    "evolveexportDynamoBucketName": "evolve-export-dynamo-242201270467-us-east-1",
    "evolvememoriesBucketName": "evolve-memories-242201270467-us-east-1",
    "securityGroupId": "sg-0261d91401bf2b59e",
    "evolveUserPoolId": "us-east-1_bLI9m6YT1",
    "evolveGuardDutyMalwareAlertTopicArn": "arn:aws:sns:us-east-1:242201270467:guardduty-malware-alerts",
    "evolveUserPoolClientId": "1lefo5mva1pgdr4ihra4kbqi0v",
    "evolveCognitoDomain": "vbc-242201270467-us-east-1",
    "evolveSecurityGroupId": "sg-0261d91401bf2b59e",
    "evolveNexusCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E8SXFJY6KETZ7",
    "evolveNexusCloudFrontDistributionId": "E8SXFJY6KETZ7",
    "evolveNexusFrontendBucket": "evolve-nexus-frontend-242201270467-us-east-1",
    "evolveNexusSubDomain": "vbc.nexus",
    "evolveOSFrontendBucketName": "evolve-os-frontend-242201270467-us-east-1",
    "evolveOSCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E26PC4BO88KB08",
    "evolveOSSubDomain": "vbc.os",
    "evolveOSCloudFrontDistributionId": "E26PC4BO88KB08",
    "evolveNascoDomain": "vbsp.test.nasco.com",
    "evolveApiProxyUrl": "https://vbc-proxy.vbsp.test.nasco.com",
    "evolveApiCloudFrontDistributionArn": "arn:aws:cloudfront::242201270467:distribution/E36ATON8KZONQ3",
    "signingProfileVersionArn": "arn:aws:signer:us-east-1:242201270467:/signing-profiles/signingProfile_KXRrHiUJKZn0/NAl7vQXhau",
    "custodianRoleName": "nasco-c7n",
    "errorTopicArn": "arn:aws:sns:us-east-1:242201270467:c7n-errors",
    "signingProfileName": "signingProfile_KXRrHiUJKZn0",
    "scheduleGroupName": "CloudCustodian",
    "policySGId": "sg-017e970a1919fad6f",
    "custodianRoleArn": "arn:aws:iam::242201270467:role/nasco-admin/nasco-c7n",
    "scheduleRoleArn": "arn:aws:iam::242201270467:role/nasco-admin/nasco-c7n-schedule",
    "custodianAdminRoleArn": "arn:aws:iam::242201270467:role/nasco-admin/nasco-c7n-admin",
    "tenableOneRoleArn": "arn:aws:iam::242201270467:role/nasco-admin/nasco-tenable-one",
    "bedrockLogging": "Yes",
    "logicMonitorRoleArn": "arn:aws:iam::242201270467:role/nasco-admin/nasco-logicmonitor",
    "snsKMSKeyAliasName": "alias/nasco/sns",
    "cfLoggingBucketName": "cloudfront-logs-242201270467-us-east-1",
    "s3LoggingBucketName": "s3-access-logs-242201270467-us-east-1",
    "breakGlassRoleArn": "arn:aws:iam::242201270467:role/nasco-admin/nasco-break-glass",
    "permsBoundaryPolicyARN": "arn:aws:iam::242201270467:policy/nasco/builder-permissions-boundary",
    "deploymentBucketName": "deployment-242201270467-us-east-1",
    "opsPermsBoundaryPolicyARN": "arn:aws:iam::242201270467:policy/nasco/ops",
    "BaselineCloudFrontACLARN": "arn:aws:wafv2:us-east-1:242201270467:global/webacl/NASCO-CloudFront-Baseline/a668a078-cfa3-4054-83fa-a8cc7f2c14ef",
    "TerraformStateBucketName": "tfstate-242201270467-us-east-1",
    "oidcProviderArn": "arn:aws:iam::242201270467:oidc-provider/api.bitbucket.org/2.0/workspaces/nascodevelopment/pipelines-config/identity/oidc",
    "BaselineConfigDeliveryChannel": "aws-controltower-BaselineConfigDeliveryChannel",
    "BaselineConfigRecorder": "aws-controltower-BaselineConfigRecorder",
    "LocalSecurityTopicName": "aws-controltower-SecurityNotifications",
    "LocalSecurityTopic": "arn:aws:sns:us-east-1:242201270467:aws-controltower-SecurityNotifications",
    "BaselineConfigRole": "arn:aws:iam::242201270467:role/aws-controltower-ConfigRecorderRole",
    "env": "dev"
}
export { COMPILED_CONSTANTS }